import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { BrowserView, MobileView } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import { cacheShowCardHint } from '../../utilities/caching';
import { dynamicAssets } from '../../utilities/helpers';
import { useUsEnv } from '../../utilities/sharedHooks/useUsEnv';

const HintBodyLayout = ({ data, path }) => {
  const { t: translate } = useTranslation();
  const [dataIndex, setIndex] = useState(0);
  const history = useHistory();
  const hideHintModal = () => {
    cacheShowCardHint(false);
    history.push(path);
  };
  useEffect(() => {
    cacheShowCardHint(true);
  }, []);

  const { isUsEnv } = useUsEnv();

  return (
    <>
      <BrowserView className="d-flex w-auto h-auto w-100 bg-lighter h-100 flex-row">
        <div className="w-33 d-flex bg-light h-100 h-auto ">
          <div className="d-flex w-100  h-100 flex-column p-4 ms-5 mx-3">
            <div className="text-f4 w-100 text-bold">
              <p>{translate('card_hint_title')}</p>
            </div>
            <div className=" w-100 h-100  align-items-end d-flex border-0 pt-4 pe-5">
              <div className="d-flex flex-column w-100">
                <p className="text-f6 text-shadow text-bold mb-2">
                  {translate('hint_step')
                    .replace('__CURRENTSTEP__', dataIndex + 1)
                    .replace('__TOTAL__', data.length)}
                </p>
                <p className="h1 text-bold mb-4">
                  {translate(
                    isUsEnv ? data[dataIndex]?.cardStepUsTitle : data[dataIndex]?.cardStepTitle
                  )}
                </p>
                <p className="text-f5 text-shadow mb-3">
                  {translate(data[dataIndex]?.cardStepSubtitle)}
                </p>
                <div
                  className={`w-100 mt-4 d-flex mb-5 ${
                    dataIndex === 0 ? 'justify-content-end' : 'justify-content-between'
                  }`}>
                  {dataIndex !== 0 && (
                    <button
                      onClick={() => setIndex(dataIndex - 1)}
                      className="btn border-grey border text-f5  w-35 me-2"
                      type="button">
                      <img alt="clipboard" src="./assets/images/left-arrow.svg" />
                    </button>
                  )}
                  {dataIndex === data?.length - 1 ? (
                    <button
                      onClick={hideHintModal}
                      className="btn btn-primary  text-f5 w-35 text-bold"
                      type="button">
                      {translate('got_it')}
                      <img className="ms-2" alt="clipboard" src="./assets/images/right-arrow.svg" />
                    </button>
                  ) : (
                    <button
                      onClick={() => setIndex(dataIndex + 1)}
                      className="btn btn-primary  text-f5 w-35 text-bold"
                      type="button">
                      {translate('next')}
                      <img className="ms-2" alt="clipboard" src="./assets/images/right-arrow.svg" />
                    </button>
                  )}
                </div>

                <div className="mt-4 mb-4 d-flex flex-row justify-content-center">
                  {data.map((item, index) => (
                    <div
                      key={data[dataIndex]}
                      style={{
                        background: index < dataIndex + 1 ? 'white' : '#565656',
                        height: '2px',
                      }}
                      className="w-30 me-2 "
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-70  h-100  h-auto d-flex align-items-center justify-content-center">
          <img className="w-85" alt="clipboard" src={dynamicAssets(data[dataIndex]?.image)} />
        </div>
      </BrowserView>
      <MobileView className="d-flex w-auto h-auto bg-lighter w-100 h-100 flex-column  overflow-y-scroll">
        <div className="d-flex w-100  h-100 flex-column ">
          <div className="d-flex h-60 w-100 w-auto bg-lighter flex-column p-4">
            <div className="mt-4 mb-4  d-flex flex-row justify-content-center">
              {data.map((item, index) => (
                <div
                  key={data[dataIndex]}
                  style={{
                    background: index < dataIndex + 1 ? 'white' : '#565656',
                    height: '2px',
                  }}
                  className="w-30 me-2 "
                />
              ))}
            </div>
            <div className="text-f5 w-100 mb-4">
              <p>{translate('card_hint_title')}</p>
            </div>
            <img alt="clipboard" src={dynamicAssets(data[dataIndex]?.imageMobile)} />
          </div>
          <div className="d-flex w-100 flex-column justify-content-between bg-light h-40 p-4">
            <div>
              <p className="text-f4 text-bold mb-2">
                {translate(
                  isUsEnv ? data[dataIndex]?.cardStepUsTitle : data[dataIndex]?.cardStepTitle
                )}
              </p>
              <p className="text-f5 text-shadow mb-2">
                {translate(data[dataIndex]?.cardStepSubtitle)}
              </p>
            </div>
            <div
              className={`w-100  d-flex mb-4  ${
                dataIndex === 0 ? 'justify-content-end' : 'justify-content-between'
              }`}>
              {dataIndex !== 0 && (
                <button
                  onClick={() => setIndex(dataIndex - 1)}
                  className="btn border-grey border text-f5 mt-4 w-30 me-2"
                  type="button">
                  <img alt="clipboard" src="./assets/images/left-arrow.svg" />
                </button>
              )}
              {dataIndex === data?.length - 1 ? (
                <button
                  onClick={hideHintModal}
                  className="btn btn-primary  text-f5 mt-4 w-30 text-bold"
                  type="button">
                  {translate('got_it')}
                  <img className="ms-2" alt="clipboard" src="./assets/images/right-arrow.svg" />
                </button>
              ) : (
                <button
                  onClick={() => setIndex(dataIndex + 1)}
                  className="btn btn-primary  text-f5 mt-4 w-30 text-bold"
                  type="button">
                  {translate('next')}
                  <img className="ms-2" alt="clipboard" src="./assets/images/right-arrow.svg" />
                </button>
              )}
            </div>
          </div>
        </div>
      </MobileView>
    </>
  );
};
export default HintBodyLayout;

HintBodyLayout.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  path: PropTypes.string,
};

HintBodyLayout.defaultProps = {
  data: null,
  path: null,
};
